import React, { useEffect, useState } from 'react';
import { DatumId, ResponsiveSunburst } from '@nivo/sunburst';
import { MathToFixed } from '../components/Utils';
import { useUiContext } from '../components/Contexts/UIContext/uiCtx';

interface UserTaskHoursSunburstProps {
    SunburstChartData: any[];
    ProjectSelected: string;
    NewProjectSelected: (selected: DatumId) => void;
}

function UserTaskHoursSunburst(props: UserTaskHoursSunburstProps) {
    const [sunburstChartData, setSunburstChartData] = useState<any>({ name: 'nivo' });

    const { isDarkmode } = useUiContext();

    useEffect(() => {
        if (props.SunburstChartData != null && props.SunburstChartData != undefined) {
            if (props.SunburstChartData.length > 0) {
                console.debug('Raw Sunburst Chart Data', props.SunburstChartData, props.ProjectSelected);

                const chartData = { name: 'nivo', children: [] };
                const rawdata = [...props.SunburstChartData];
                rawdata?.forEach(perioddata => {
                    const newprojactualsdata = {};

                    perioddata?.chartDataProjects?.forEach(projectdata => {
                        let project: any = chartData.children.filter(projs => {
                            return projs.name === projectdata.projectname;
                        });
                        if (project != null && project != undefined && project.length <= 0) {
                            project = { name: projectdata.projectname, children: [] };
                            chartData.children.push(project);
                        } else {
                            project = project[0];
                        }
                        if (props.ProjectSelected == null || props.ProjectSelected == projectdata.projectname) {
                            projectdata?.chartDataTasks?.forEach(taskdata => {
                                let actualhours = 0;
                                taskdata?.chartDataTimes?.forEach(timedata => {
                                    actualhours = actualhours + timedata.actual;
                                });

                                let task: any = project.children.filter(t => {
                                    return t.name === taskdata.taskname;
                                });

                                if (task != null && task != undefined && task.length <= 0) {
                                    task = { name: taskdata.taskname, Hours: 0 };
                                    project.children.push(task);
                                } else {
                                    task = task[0];
                                }
                                task['Hours'] = task['Hours'] + actualhours;
                            });
                        }
                    });
                });
                console.debug('Sunburst Chart Data', chartData);
                chartData.children = chartData.children.sort((a, b) => {
                    return a.name > b.name ? -1 : 1;
                });
                setSunburstChartData(chartData);
            }
        }
    }, [props.SunburstChartData, props.ProjectSelected]);
    const CenteredMetric = ({ nodes, centerX, centerY }: any) => {
        const total2 = nodes.reduce((total, datum) => {
            if (datum.depth == 2) return total + datum.value;
            else return total;
        }, 0);
        console.log('nodes', nodes);
        return (
            <>
                <text
                    x={centerX}
                    y={centerY}
                    textAnchor="middle"
                    dominantBaseline="central"
                    fill={isDarkmode ? '#ffffff' : ''}
                    style={{
                        fontSize: '3em',
                        fontWeight: 400,
                    }}
                >
                    {MathToFixed(total2, 2)}
                </text>
                <text
                    x={centerX}
                    y={centerY + 30}
                    textAnchor="middle"
                    dominantBaseline="central"
                    fill={isDarkmode ? '#ffffff' : ''}
                    style={{
                        fontSize: '1em',
                        fontWeight: 200,
                    }}
                >
                    hours
                </text>
            </>
        );
    };
    return (
        <ResponsiveSunburst
            data={sunburstChartData}
            onClick={(data, e) => {
                console.debug(`Project Selected: ${data['id']}, selected data: ${data['value']}`, e, data);
                if (data['path'] != undefined && data['path'].length == 2) {
                    e.stopPropagation();
                    props.NewProjectSelected(data.id);
                }
            }}
            margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
            id="name"
            isInteractive={true}
            colors={['#31B6FD', '#4584D3', '#5BD078', '#A5D028', '#F5C040', '#05E0DB', '#3153FD', '#4C45D3', '#5BD0B0', '#54D028', '#D0F540', '#057BE0']}
            theme={
                isDarkmode
                    ? {
                          textColor: '#ffffff',
                          tooltip: { basic: { color: '#000000' } },
                      }
                    : {}
            }
            animate={true}
            valueFormat=" >-,.10~"
            value="Hours"
            cornerRadius={0}
            borderColor="white"
            borderWidth={1}
            childColor={{ from: 'color', modifiers: [['brighter', 0.4]] }}
            enableArcLabels={true}
            arcLabel="id"
            arcLabelsSkipAngle={40}
            arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2.0]] }}
            layers={['arcs', 'arcLabels', CenteredMetric]}
        />
    );
}

export default UserTaskHoursSunburst;
